import { render, staticRenderFns } from "./Createservice.vue?vue&type=template&id=24984de3"
import script from "./Createservice.vue?vue&type=script&lang=js"
export * from "./Createservice.vue?vue&type=script&lang=js"
import style0 from "./Createservice.vue?vue&type=style&index=0&id=24984de3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserCountry: require('/root/workspace/web-company_Yo6Q/components/userLogin/userCountry.vue').default})
